import React from 'react';
import PropTypes from 'prop-types';
const Moment = require('moment-timezone');

const propTypes = {
    className: PropTypes.string,
    date: PropTypes.string,
    showTime: PropTypes.bool,
    shortMonth: PropTypes.bool,
    customFormat: PropTypes.string,
};

const defaultProps = {
    className: "",
    date: "2015-11-01T00:00:00.000Z",
    showTime: false,
    showSeconds: false,
    shortMonth: false,
    customFormat: '', // overrides showTime, showSeconds, shortMonth using custom momentjs format
};

function DateString({ className, date, showTime, showSeconds, shortMonth, customFormat}) {
    const mDate = Moment.tz(date, Moment.tz.guess());
    let dateString;

    if (!customFormat) {
        let dateFormat = "MMMM D YYYY";
        if (shortMonth) {
            dateFormat = "MMM D YYYY";
        }

        dateString = mDate.format(dateFormat);

        if (showTime) {
            //TODO: is 'date' prop ever passed without a timezone specified? (-400, +000, etc)
            const timeFormat = showSeconds ? "HH:mm:ss z" : 'HH:mm z';
            dateString = `${dateString} ${mDate.format(timeFormat)}`;
        }
    }
    else {
        dateString = mDate.format(customFormat);
    }

    return (
        <span className={`date ${className}`}>
            {dateString}
        </span>
    );
}

DateString.propTypes = propTypes;
DateString.defaultProps = defaultProps;
export default DateString;
